import { User } from 'model';
import { SearchBar } from './Forms/SearchBar.js';
import { useEffect, useState } from 'react';
import { QuirkLoader } from './QuirkLoader.js';
import { Virtuoso } from 'react-virtuoso';
import { IconArrowBack, IconDeactivate, IconSearch } from './QuirkIcons/index.js';
import { NoResults } from './NoResults.js';
import { IonItem, useIonModal } from '@ionic/react';
import { UserItem } from './admin/UserItem.js';
import { useQueryWithDebounce } from '../hooks/useQueryWithDebounce.js';
import { useLazySearchUserQuery } from '../api/UserApi.js';
import { QuirkIonContent } from './QuirkIonContent.js';
import { IconButton } from './IconButton.js';
import { Header } from './Header.js';
// eslint-disable-next-line css-modules/no-unused-class
import formStyles from './Forms/FormFields.module.css';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../styles/Shared.module.css';
import styles from './SelectUser.module.css';

export type SelectUserProps = {
	onChange?: (user?: User) => void | Promise<void>;
	value?: User;
	label?: string;
};
type SearchUsersProps = {
	onSelect: (user: User) => void;
	onDismiss: () => void;
};

function SearchUsers({ onSelect, onDismiss }: SearchUsersProps) {
	const [search, setSearch] = useState('');
	const { trigger, data, isFetching, isLoading } = useQueryWithDebounce(useLazySearchUserQuery, 100);
	return (
		<QuirkIonContent flush>
			<>
				<Header
					title="Select User"
					left={<IconButton icon={<IconArrowBack />} onClick={() => onDismiss()} />}
				/>
				<SearchBar
					placeholder="Search Users"
					value={search}
					onChangeAction={({ detail: { value } }) => {
						setSearch(value);
						trigger(value);
					}}
					isFetching={isFetching}
					isLoading={isLoading}
				/>
				<QuirkLoader
					isLoading={isLoading}
					loadingMessage="Loading users..."
					data={data}
					noResults={
						<NoResults
							heading="No users found."
							subheading="Refine or clear your search filters."
							icon={<IconSearch />}
						/>
					}
				>
					<Virtuoso
						style={{ height: '25vh' }}
						totalCount={data?.length}
						data={data}
						itemContent={(index, user: User) => {
							return (
								<IonItem className={sharedStyles.ionItem}>
									<div
										onClick={() => {
											onSelect(user);
										}}
									>
										<UserItem user={user} modal={true} />
									</div>
								</IonItem>
							);
						}}
					/>
				</QuirkLoader>
			</>
		</QuirkIonContent>
	);
}

export function SelectUser({ onChange, value, label }: SelectUserProps) {
	const [state, setState] = useState(value);
	const [presentModal, dismissModal] = useIonModal(
		<SearchUsers
			onSelect={user => {
				setState(user);
				dismissModal();
				onChange?.(user);
			}}
			onDismiss={() => dismissModal()}
		/>
	);
	useEffect(() => {
		setState(value);
	}, [value]);
	const clearState = () => {
		setState(undefined);
	};
	return (
		<div>
			{label && <label className={formStyles.label}>{label}</label>}
			{state && (
				<div className={styles.userItemWrapper}>
					<UserItem user={state} />
					<div className={styles.clearButtonWrapper}>
						<IconButton icon={<IconDeactivate />} onClick={clearState} />
					</div>
				</div>
			)}
			{!state && <IconButton icon={<IconSearch />} label="Search Users" onClick={presentModal} />}
		</div>
	);
}
